var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgMacaron = function SvgMacaron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 5.823c0-1.293-.606-2.433-1.742-3.27-1.819-1.293-5-1.977-9.394-2.053h-.455C2.795.5.902 3.238.826 5.595v.152c0 2.814 10.757 2.966 11.212 2.966h.53c2.652 0 5.152-.228 7.046-.608 2.424-.457 3.636-1.141 3.636-2.13V5.9c-.038 0-.038 0-.028-.01a.087.087 0 00.028-.066zm-.682 1.534c-.379 0-.606.356-.606.95-.303.952-3.863 2.497-10 2.378-6.136-.119-9.697-1.783-10-2.734 0-.475-.303-.951-.606-.951s-.606.476-.606.951c0 4.399 10.758 4.637 11.212 4.637h.303c1.743 0 10.985-.238 10.985-4.28-.076-.476-.303-.951-.682-.951zm-.606 4.826c0-.595.227-.951.606-.951s.606.475.682.95c0 4.043-9.242 4.28-10.985 4.28h-.303c-.454 0-11.212-.237-11.212-4.636 0-.476.303-.951.606-.951s.606.476.606.951c.303.951 3.864 2.615 10 2.734 6.137.12 9.697-1.426 10-2.377z",
    fill: "#1F1F1F"
  })));
};

export default SvgMacaron;